import React from "react";
import { useSelector } from "react-redux";
import { Formik } from "formik";
import axios from "axios";
import queryString from "query-string";

import DispensaryAlertBlock from "@col-care/common/blocks/dispensary-alert/DispensaryAlert";

const DispensaryAlert = (props) => {
  // console.log('DispensaryAlert form props:', props)
  const state = useSelector((state) => state);

  const formId = hubspotFormIdByState[props.state];

  if (!formId) {
    return null;
  }

  const hsCooky = props.cookies?.cookies?.hubspotutk;

  return (
    <Formik
      initialValues={{
        email: "",
      }}
      validate={(values) => {
        const errors = {};

        if (!values.email) {
          errors.email = "Required";
        } else if (
          !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        ) {
          errors.email = "Invalid email address";
        }

        return errors;
      }}
      onSubmit={(values, { setSubmitting, setStatus }) => {
        const postData = queryString.stringify({
          email: values.email,
          hs_context: JSON.stringify({
            hutk: `${hsCooky}`,
            pageName: `${props.page_name}`,
            pageUrl: `${props.page_url}`,
          }),
        });

        const PORTAL_ID = "5757798";
        const FORM_GUID = `${formId}`;

        axios
          .post(
            `https://forms.hubspot.com/uploads/form/v2/${PORTAL_ID}/${FORM_GUID}`,
            postData,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            }
          )
          .then(({ data }) => {
            // console.log(data);
            setStatus({ success: true });
          })
          .catch((error) => {
            // console.log(error);
            setStatus({ success: false });
          })
          .then(() => {
            setSubmitting(false);
          });
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        status,
      }) => {
        return (
          <DispensaryAlertBlock
            values={values}
            errors={errors}
            touched={touched}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            status={status}
            {...props}
          />
        );
      }}
    </Formik>
  );
};

DispensaryAlert.displayName = "DispensaryAlert";

export default DispensaryAlert;

// @todo: put in CMS
const hubspotFormIdByState = {
  "New York": "c81f1eef-278a-4886-81c2-826ddddb7c88",
  Delaware: "f108fd36-9205-43a4-ba17-4ca45c5f3f47",
  Maryland: "cba71017-878b-48c6-be22-a87a1912e69b",
  Ohio: "7932c113-3548-42c6-86ec-2a5ec2bad707",
  Pennsylvania: "801c6fb5-e90b-410f-9330-a225d9c08e1c",
};
